export default "__VITE_ASSET__CL9R3KCZ__"